// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmationBanner-cls1_liF","cls2":"ConfirmationBanner-cls2__hJ ConfirmationBanner-cls1_liF"};